import React from "react";

/**
 * Shared Kids button. variant "primary" = brand fill; "secondary" = white + brand border.
 * Fredoka 600, min-height 44px (kid-facing hit target), logical padding only.
 */
export default function Button({
  variant = "primary",
  className = "",
  children,
  ...rest
}) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-2xl px-6 min-h-[44px] " +
    "font-display font-semibold text-[15px] transition active:scale-[0.97] " +
    "disabled:opacity-50 disabled:pointer-events-none";

  const variants = {
    primary: "bg-brand text-white shadow-primary hover:bg-brand-hover",
    secondary: "bg-white text-brand border-2 border-brand hover:bg-orange-50",
  };

  return (
    <button
      className={`${base} ${variants[variant] || variants.primary} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
